export const menuOptions: any[] = [
  {
    text: '',
    items: [
      {
        text: 'Bauelemente',
        items: [{ text: 'Lokationen',name:'locations' },{ text: 'Kontakte',name:'contacts' }, { text: 'Schächte',name:'shafts'}, { text: 'Engpässe',name:'bottlenecks'}, { text: 'Feederkabel',name:'feederCable'}, 
          { text: 'CO-Aufschaltung',name:'coActivation'}, { text: 'Feederspleissungen',name:'feederSplices'}, { text: 'Muffen',name:'sleeves'}, { text: 'OTO',name:'locationsOto'}]
      },
      {
        text: 'Verträge',
        name:'contracts' 
      },
      {
        text: 'Bewilligungen',
        items: [{ text: 'Schächte',name:'permits-shafts' }, { text: 'Engpässe',name:'permits-bottlenecks' }, { text: 'Werklöcher',name:'permits-workHoles' }]
      },
      {
        text: 'Site Visit',
        name:'siteVisit' 
      },
      {
        text: 'Ausführungsdesign',
        name:'executionDesign' 
      },
      {
        text: 'Spezifikation',
        name:'specification' 
      },
      {
        text: 'Drop',
        name:'drop' 
      },
      {
        text: 'OTO',
        name:'oto' 
      },
      {
        text: 'Belag',
        name:'covering' 
      },
      {
        text: 'Dokumentation / QC',
        items: [{ text: 'Inhouse',name:'qc-inhouse' }, { text: 'OTO',name:'qc-oto' }, { text: 'Schachte',name:'qc-schachte' }, { text: 'Muffen',name:'qc-muffe' }, { text: 'CO',name:'qc-co' }, { text: 'Werkloch / Graben',name:'qc-werkloch-graben' }]
      },
      {
        text: 'Inventarisierung',
        name:'inventory' 
      },
      {
        text: 'Abnahmen',
        name:'inspection' 
      }
    ]
  }
];
